import { TwinDictionary } from '../../../utils/globals/dictionary'

export const filterOnlyTableDataSelectedCheckboxLayout = (tableData: TwinDictionary[] | null) => {
    const parsedData: TwinDictionary[] = JSON.parse(JSON.stringify(tableData))
    const selectedTableData: TwinDictionary[] = []
    const selectedIds: number[] = []
    if (parsedData) {
        for (const k in parsedData) {
            const element = parsedData[k]
            if (element.selected) {
                selectedTableData.push(element)
                selectedIds.push(element.id)
            }
        }
    }
    return { selectedTableData, selectedIds }
}